import { render, staticRenderFns } from "./ElegantTabs.vue?vue&type=template&id=5e9e23c0&scoped=true"
import script from "./ElegantTabs.vue?vue&type=script&lang=js"
export * from "./ElegantTabs.vue?vue&type=script&lang=js"
import style0 from "./ElegantTabs.vue?vue&type=style&index=0&id=5e9e23c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9e23c0",
  null
  
)

export default component.exports